// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: true,
  apihost: 'https://sl-atom-stg-tas-server.revenuedev.org/web',
  apihostDomain : 'https://sl-atom-stg-tas-server.revenuedev.org',
  authServerhost: 'https://sso.revenuedev.org/?returnUrl=https://sl-atom-stg-govin.revenuedev.org',
  authServerhostLogout: 'https://sso.revenuedev.org/logout?returnUrl=https://sl-atom-stg-govin.revenuedev.org',
  whitelistDomain: "sl-atom-stg-tas-server.revenuedev.org",
  blacklistDomain: "sl-atom-stg-tas-server.revenuedev.org/web/auth",
  immatriculationWeb: "https://ivory-coast-immatriculation.revenuedev.org",
  boundary: [ -13.3186960220337,6.90220165252686,-10.250563621521, 10.0158452987671 ],
  default_lang: 'en'
};

